export default "__VITE_ASSET__85668d0d__"